import classNames from 'classnames'
import { ElTable } from 'element-plus'
import type { FunctionalComponent } from 'vue'
import './HocElTable.scss'

type ElTableProps = InstanceType<typeof ElTable>['$props']

export const HocElTable: FunctionalComponent<ElTableProps> = (_props, { slots, attrs }) => {
  return (
    <ElTable {...attrs} class={classNames('hoc-el-table', attrs.class as string)}>
      {slots}
    </ElTable>
  )
}
HocElTable.inheritAttrs = false
